import axios from 'axios'

import { requestTurnstileToken } from './turnstileChallenge'
import secureStorage from '../utils/secureStorage'
import { handleAuthError } from '../helpers/Auth'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem('logged_user')
    config.headers = config.headers || {}
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else if (config.headers?.Authorization) {
      delete config.headers.Authorization
    }
    return config
  },
  (error) => Promise.reject(error),
)

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config } = error || {}

    if (
      response?.status === 429 &&
      response.data?.challenge_required &&
      config &&
      !config.__turnstileRetried
    ) {
      const { site_key: siteKey, retry_after: retryAfter } = response.data
      try {
        const token = await requestTurnstileToken({ siteKey, retryAfter })
        if (token) {
          const delaySeconds = Number(retryAfter)
          if (Number.isFinite(delaySeconds) && delaySeconds > 0) {
            await wait(delaySeconds * 1000)
          }
          const headers = { ...(config.headers || {}) }
          headers['X-Turnstile-Token'] = token
          const updatedConfig = {
            ...config,
            headers,
            __turnstileRetried: true,
          }
          return api.request(updatedConfig)
        }
      } catch (challengeError) {
        console.warn('Turnstile challenge not completed', challengeError)
      }
    }

    handleAuthError(error)
    return Promise.reject(error)
  },
)

export default api
